import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'
import { CardUI, CardData } from '../types'
import { Percentage } from './Percentage'
import { RadialProgress } from './RadialProgress'
import { Text } from './Text'
import { KeyValue } from './KeyValue'

export function SingleCard({ card, data }: { card: CardUI; data: CardData }) {
  return (
    <Card className="flex flex-col border-none bg-background shadow">
      <CardHeader>
        <CardTitle className="text-lg">{card.title}</CardTitle>
        {card.description && <CardDescription>{card.description}</CardDescription>}
      </CardHeader>
      <CardContent className="flex-1">
        {card.config.type === 'radial' ? (
          <RadialProgress config={card.config} data={data} />
        ) : card.config.type === 'percentage' ? (
          <Percentage config={card.config} data={data} />
        ) : card.config.type === 'text' ? (
          <Text config={card.config} data={data} />
        ) : card.config.type === 'key-value' ? (
          <KeyValue config={card.config} data={data} />
        ) : (
          <pre>{JSON.stringify({ config: card.config, data }, null, 2)}</pre>
        )}
      </CardContent>
    </Card>
  )
}
